module.exports = __webpack_public_path__ + "img/job_06.011f2529.png";